import { z } from 'zod';

export const dealerBankAccountSchema = z.object({
    account_name: z.string().min(1, 'Account name is required'),
    account_number: z.string().min(8, 'Account number must be 8 digits').max(8, 'Account number must be 8 digits').regex(/^\d+$/, 'Account number must be numeric'),
    sort_code: z.string().min(6, 'Sort code must be 6 digits').max(6, 'Sort code must be 6 digits').regex(/^\d+$/, 'Sort code must be numeric'),
    bank_name: z.string().optional(),
    is_primary: z.boolean().optional(),
});

export type DealerBankAccountFormInput = z.infer<typeof dealerBankAccountSchema>;
